export default function PrivacyPage() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-10 text-sm text-gray-700 leading-relaxed">
      <h1 className="text-2xl font-bold mb-1">Privacy Policy</h1>
      <p className="text-xs text-gray-500 mb-6">Version privacy-2026-07 · Automates 2026 Conference Companion · private beta</p>

      <h2 className="font-semibold text-lg mt-6 mb-2">What we hold</h2>
      <p>Your account (email, display name), the show-floor data you create (booth notes, question answers, audio recordings of vendor conversations, track progress), and security logs (action, IP, country, timestamp) for every change made through the service. The exhibitor catalog is application content, not your data.</p>

      <h2 className="font-semibold text-lg mt-6 mb-2">Your rights (self-service, immediate)</h2>
      <ul className="list-disc pl-5 space-y-1.5">
        <li><b>Export</b> — Profile → Privacy &amp; Data → "Download my data": complete JSON of everything above.</li>
        <li><b>Erasure</b> — Profile → Privacy &amp; Data → "Erase my account": destroys your account, notes, answers, recordings (including audio in cloud storage), and progress. Security logs are pseudonymized, not deleted (legitimate interest).</li>
        <li><b>Rectification</b> — edit anything, any time.</li>
      </ul>

      <h2 className="font-semibold text-lg mt-6 mb-2">Recording consent reminder</h2>
      <p>Audio recordings capture vendor conversations — you are responsible for complying with local consent-to-record laws when using that feature on the show floor.</p>

      <h2 className="font-semibold text-lg mt-6 mb-2">Processors</h2>
      <p>Cloudflare (hosting, database, storage, edge) · Resend (transactional email) · Anthropic-based AI proxy (Ava prompts; not used for model training per provider terms).</p>

      <h2 className="font-semibold text-lg mt-6 mb-2">Retention &amp; residency</h2>
      <p>Sign-in codes: 10 minutes. Security logs: 400 days. Everything else lives until you delete it. Data is stored on Cloudflare's global network; platform backups persist up to ~30 days after deletion. Jurisdiction-restricted regions are blocked at the network edge per trade-sanction requirements.</p>

      <h2 className="font-semibold text-lg mt-6 mb-2">Contact</h2>
      <p>hrashe2@gmail.com</p>
    </div>
  )
}
